exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remitos-button {\n  padding: 0 10px;\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.25);\n  color: white;\n  font-size: 14px;\n  border: none;\n  position: relative; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/administracion-header/administracion-header.component.scss
// module id = ../../../../../src/app/components/administracion/administracion-header/administracion-header.component.scss
// module chunks = 0